import React from "react";
import { LookupTableDropdown } from "@modules/spreadsheets/pages/spreadsheet-details/components/spreadsheet-result/components/table/components/body/components/row/components/cell/LookupTableDropdown";
import { LookupTableInput } from "@modules/spreadsheets/pages/spreadsheet-details/components/spreadsheet-result/components/table/components/body/components/row/components/cell/LookupTableInput";

export interface LookupTableFilterProps {
  value?: string | number;
  onSave: (params: { value?: string | number; metadata: { property: string } }) => void;
  metadata: {
    property: string;
  };
  className?: string;
  lookupValues: Record<string, string[]> | {};
}

export const LookupTableFilter: React.FC<LookupTableFilterProps> = ({
  value,
  onSave,
  metadata,
  className = "",
  lookupValues,
}) => {
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [dropdownPosition, setDropdownPosition] = React.useState({
    x: 0,
    y: 0,
    placement: "bottom" as const,
  });

  const wrapperRef = React.useRef<HTMLDivElement>(null);

  const openDropdown = () => {
    if (wrapperRef.current) {
      const rect = wrapperRef.current.getBoundingClientRect();
      setDropdownPosition({
        x: rect.left + rect.width / 2,
        y: rect.bottom + 5,
        placement: "bottom",
      });
      setIsDropdownOpen(true);
    }
  };

  const handleSelection = (selectedValue: string) => {
    onSave({
      value: selectedValue,
      metadata,
    });
    setIsDropdownOpen(false);
  };

  const handleClose = () => {
    setIsDropdownOpen(false);
  };

  return (
    <>
      <div ref={wrapperRef} className={className}>
        <LookupTableInput value={String(value ?? "")} onOpen={openDropdown} style={{paddingLeft: "4px"}}/>
      </div>

      <LookupTableDropdown
        isOpen={isDropdownOpen}
        onClose={handleClose}
        lookupValues={lookupValues}
        onSelect={handleSelection}
        position={dropdownPosition}
      />
    </>
  );
};

